module.exports = __webpack_public_path__ + "static/media/twitter.02d41092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/twitter.svg
// module id = 1850
// module chunks = 0